module.exports = __webpack_public_path__ + "static/img/kemudahan-pembayaran.52b8876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/kemudahan-pembayaran.png
// module id = 0RZM
// module chunks = 1